/**
 * Cart drawer compatibility for Session Flow.
 * - AJAX-ifies collection card "Add to Cart" forms (so they don't redirect to /cart)
 * - Opens Session Flow cart only
 * - Never opens the theme cart drawer when Session Flow is present
 */
(function () {
  var submitBound = false;
  var cartListenersBound = false;

  function isSessionFlowActive() {
    return !!(
      typeof window.sfOpenCartDrawer === 'function' ||
      window.__sfCartDrawerLoaded ||
      window.SessionFlow ||
      document.getElementById('sf-cart-styles')
    );
  }

  function openSessionFlowCart() {
    if (typeof window.sfRefreshCartDrawer === 'function') {
      try {
        window.sfRefreshCartDrawer();
      } catch (e) {}
    }
    if (typeof window.sfOpenCartDrawer === 'function') {
      try {
        window.sfOpenCartDrawer();
        return true;
      } catch (e) {}
    }
    return false;
  }

  function closeThemeCartDrawer() {
    if (typeof window.__sfSuppressThemeCart === 'function') {
      try {
        window.__sfSuppressThemeCart();
      } catch (e) {}
    }

    document.body.classList.remove(
      'show-cart-summary',
      'product-added-to-cart',
      'cart-summary-open',
      'overflow-hidden',
      'cart-drawer-open'
    );

    var summary = document.getElementById('cart-summary');
    if (summary) {
      summary.classList.remove('cart-summary--active', 'active');
      summary.setAttribute('aria-hidden', 'true');
    }

    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      if (typeof drawer.close === 'function') {
        try {
          drawer.close();
        } catch (e) {}
      }
      var dialog = drawer.querySelector('dialog');
      if (dialog && dialog.open) {
        try {
          dialog.close();
        } catch (e) {}
      }
    }
  }

  function openActiveCart() {
    if (isSessionFlowActive()) {
      closeThemeCartDrawer();
      if (openSessionFlowCart()) return true;
      var attempts = 0;
      var timer = setInterval(function () {
        attempts++;
        closeThemeCartDrawer();
        if (openSessionFlowCart() || attempts >= 20) clearInterval(timer);
      }, 150);
      return true;
    }

    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  function disableThemeDrawerAutoOpen() {
    if (!isSessionFlowActive()) return;

    document.documentElement.classList.add('sessionflow-cart-active');

    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) drawer.removeAttribute('auto-open');
  }

  function patchCartDrawerComponent() {
    if (!isSessionFlowActive() || !customElements.get('cart-drawer-component')) return;

    var proto = customElements.get('cart-drawer-component').prototype;
    if (proto.__sessionflowPatched) return;

    proto.open = function () {
      closeThemeCartDrawer();
      openSessionFlowCart();
    };

    var originalShow = proto.showDialog;
    if (typeof originalShow === 'function') {
      proto.showDialog = function () {
        closeThemeCartDrawer();
        openSessionFlowCart();
      };
    }

    proto.__sessionflowPatched = true;
  }

  function patchThemeUpdateCartSummaries() {
    if (typeof theme === 'undefined' || !theme.updateCartSummaries || theme.updateCartSummaries.__sessionflowPatched) {
      return;
    }

    var original = theme.updateCartSummaries;
    theme.updateCartSummaries = function (openCart) {
      var shouldOpenSessionFlow = openCart && isSessionFlowActive();
      if (shouldOpenSessionFlow) {
        openCart = false;
        closeThemeCartDrawer();
      }
      var result = original.apply(theme, arguments);
      if (shouldOpenSessionFlow) {
        setTimeout(function () {
          closeThemeCartDrawer();
          openSessionFlowCart();
        }, 0);
      }
      return result;
    };
    theme.updateCartSummaries.__sessionflowPatched = true;
  }

  function onCartMutation() {
    if (!isSessionFlowActive()) return;
    closeThemeCartDrawer();
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.classList.add('loading', 'product-add--adding');
      btn.setAttribute('disabled', 'disabled');
    } else {
      btn.classList.remove('loading', 'product-add--adding');
      btn.removeAttribute('disabled');
    }
  }

  function notifyCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
    try {
      window.dispatchEvent(new CustomEvent('cc-cart-updated', { detail: { cart: cart } }));
    } catch (e) {}
  }

  function bindAjaxAddToCartForms() {
    if (submitBound) return;
    submitBound = true;

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.tagName !== 'FORM') return;

        var wantsAjax =
          form.getAttribute('data-ajax-add-to-cart') === 'true' ||
          form.classList.contains('product-form--mini');

        if (!wantsAjax) return;
        if (form.closest('product-form-component')) return;

        event.preventDefault();
        event.stopPropagation();

        var submitBtn = form.querySelector(
          '[type="submit"][name="add"], button[type="submit"], .quick-buy-modal__add-to-cart'
        );
        if (submitBtn && submitBtn.getAttribute('disabled') === 'disabled') return;

        setButtonLoading(submitBtn, true);

        var formData = new FormData(form);
        if (!formData.get('quantity')) formData.set('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function () {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
              return r.json();
            });
          })
          .then(function (cart) {
            closeThemeCartDrawer();
            notifyCartUpdated(cart);
            openActiveCart();
            if (submitBtn) {
              submitBtn.classList.add('product-add--added', 'atc-added');
              setTimeout(function () {
                submitBtn.classList.remove('product-add--added', 'atc-added');
              }, 1500);
            }
          })
          .catch(function (err) {
            var message =
              (err && (err.description || err.message)) ||
              'Could not add item to cart. Please try again.';
            console.error('Add to cart failed', err);
            alert(message);
          })
          .finally(function () {
            setButtonLoading(submitBtn, false);
          });
      },
      true
    );
  }

  function init() {
    disableThemeDrawerAutoOpen();
    patchCartDrawerComponent();
    patchThemeUpdateCartSummaries();
    bindAjaxAddToCartForms();

    if (!cartListenersBound) {
      cartListenersBound = true;
      document.addEventListener('cart:update', onCartMutation, true);
      document.addEventListener('cart:updated', onCartMutation, true);
      document.addEventListener('cart:refresh', onCartMutation, true);
    }

    if (isSessionFlowActive()) closeThemeCartDrawer();
  }

  window.TDMUpcart = {
    isActive: isSessionFlowActive,
    open: openActiveCart,
    openUpcart: openSessionFlowCart,
    closeThemeCart: closeThemeCartDrawer,
  };

  window.TDMCart = window.TDMUpcart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  customElements.whenDefined('cart-drawer-component').then(patchCartDrawerComponent);
  window.addEventListener('load', function () {
    init();
    patchThemeUpdateCartSummaries();
  });

  [500, 1500, 3000].forEach(function (delay) {
    setTimeout(init, delay);
  });
})();
